import { call, put, takeLatest } from 'redux-saga/effects';

import { ROUTES, API } from 'utils/Apis';

import { Types } from '../redux';

// worker Saga: will be fired on GET_SMS_CODE actions
function* getUserBarcode() {
  try {
    /**
     * Example data
     * url: enpoint/register/send-confirm-code
     *
     */
    const response = yield call(() => API.get(ROUTES.API_GET_USER_BARCODE));
    const data = response?.data;
    if (response.ok) {
      // In case: get sms code request success
      yield put({ type: Types.GET_USER_BARCODE_SUCCESS, data });
    } else {
      // In case: get sms code request failed
      yield put({
        type: Types.GET_USER_BARCODE_FAILED,
      });
    }
  } catch (error) {
    // in case: server error
    yield put({ type: Types.GET_USER_BARCODE_FAILED, error });
  }
}

/*
  Starts signupAccount on each dispatched `SIGN_IN` action.
*/
function* getUserBarcodeSaga() {
  yield takeLatest(Types.GET_USER_BARCODE, getUserBarcode);
}

export default getUserBarcodeSaga;
